import React, { useEffect } from "react";
import { useContext } from "react";
import { QuestionsContext, ShowPageContext } from "../../../provider/MyContexts";
import { Box, Button, Stack, Typography } from "@mui/material";
import { pages } from "../../../config";
import Settings from "./Settings";

export default function TopPage() {
  const { showPage, setShowPage } = useContext(ShowPageContext);
  const { selectedSheet, loadSheetNames } = useContext(QuestionsContext);

  const [selectedMenu, setSelectedMenu] = React.useState<string>("");

  useEffect(() => {
    loadSheetNames();
  }, []);

  if (showPage !== "top") {
    return null;
  }

  return (
    <Stack flex={1} direction={"column"} justifyContent={"center"}>
      <Stack
        width={"100%"}
        alignItems={"center"}
        justifyContent={"center"}
        spacing={1}
        sx={{
          paddingY: 3,
        }}
      >
        <Box
          component="img"
          src="assets/logo.png"
          alt="logo"
          sx={{
            width: 124,
            height: 124,
          }}
        />
        <Typography
          variant="heading_M"
          marginBottom={2}
          sx={{
            fontFamily: "'M PLUS Rounded 1c', sans-serif",
            fontWeight: 900,
          }}
        >
          {"調査票 AI"}
        </Typography>
      </Stack>
      <Stack
        flex={1}
        direction={"column"}
        spacing={2}
        // justifyContent={"center"}
        alignItems={"center"}
        sx={{
          paddingY: 2,
          paddingX: 3,
        }}
      >
        <Typography variant="body_M">さあ、はじめましょう。</Typography>
        <Stack width={"100%"} direction={"row"} spacing={2} justifyContent={"center"}>
          {pages.slice(1).map((page) => (
            <Button
              key={page.id}
              // variant="contained"
              variant={selectedMenu == page.id ? "contained" : "outlined"}
              sx={{
                width: 160,
              }}
              // onClick={() => setShowPage(page.id)}
              // disabled={!selectedSheet || page.id == "format"}
              onClick={() => setSelectedMenu(page.id)}
              disabled={page.id == "format"}
            >
              <Typography variant="button">{page.label}</Typography>
            </Button>
          ))}
        </Stack>
        <Settings selectedMenu={selectedMenu} setShowPage={setShowPage} />
      </Stack>
    </Stack>
  );
}
